"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../../../utils/helpers");
var _ListInput = _interopRequireDefault(require("./ListInput"));
require("./AddressInput.scss");
var _types = require("../../../utils/types");
var _InputChip = _interopRequireDefault(require("../InputChip/InputChip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AddressInput = function AddressInput(_ref) {
  var label = _ref.label,
    list = _ref.list,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    onEdit = _ref.onEdit,
    _onDelete = _ref.onDelete;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var inputRef = (0, _react.useRef)();
  var editRef = (0, _react.useRef)();
  var selectContact = function selectContact(contact) {
    if ((0, _helpers.isValidMail)(contact.account)) {
      onSelect(contact);
    } else {
      onSelect(_objectSpread(_objectSpread({}, contact), {}, {
        invalid: true
      }));
    }
    setValue('');
  };
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editing = _useState4[0],
    setEditing = _useState4[1];
  (0, _react.useEffect)(function () {
    if (editing !== null) editRef.current.focus();
  }, [editing]);
  var editContact = function editContact(i, c) {
    onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
      invalid: !(0, _helpers.isValidMail)(c.account)
    }));
    setEditing(null);
  };
  var blurEditing = function blurEditing(i, c) {
    if (c.account === '') {
      _onDelete(i);
      setEditing(null);
    }
  };
  var propagationWrapper = function propagationWrapper(e, action) {
    e.stopPropagation();
    action();
  };
  var inputID = 'uin-ain-input-' + label.replace(/\s+/g, '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-address-input",
    onClick: function onClick() {
      return inputRef.current.focus();
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-ain-label"
  }, label, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-ain-addresses"
  }, selected.map(function (c, i) {
    return editing === i ? /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
      key: i,
      id: inputID + i,
      ref: editRef,
      adjustable: true,
      list: list,
      value: c.account,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: function onChange(e) {
        return onEdit(i, _objectSpread(_objectSpread({}, c), {}, {
          account: e.currentTarget.value
        }));
      },
      onSelect: function onSelect(c) {
        return editContact(i, c);
      },
      onBlur: function onBlur() {
        return blurEditing(i, c);
      }
    }) : /*#__PURE__*/_react["default"].createElement(_InputChip["default"], {
      key: i,
      label: c.account,
      interactive: true,
      invalid: c.invalid,
      onClick: function onClick(e) {
        return propagationWrapper(e, function () {
          return setEditing(i);
        });
      },
      onDelete: function onDelete(e) {
        return propagationWrapper(e, function () {
          return _onDelete(i);
        });
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_ListInput["default"], {
    id: inputID,
    ref: inputRef,
    list: list,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.currentTarget.value);
    },
    onSelect: selectContact
  })));
};
AddressInput.propTypes = {
  label: _propTypes["default"].string.isRequired,
  selected: _propTypes["default"].arrayOf(_types.contactType),
  list: _propTypes["default"].arrayOf(_types.contactType),
  onSelect: _propTypes["default"].func.isRequired,
  onEdit: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func.isRequired
};
AddressInput.defaultProps = {
  selected: []
};
var _default = exports["default"] = AddressInput;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/common/AddressInput/AddressInput.js
// module id = 1430
// module chunks = 0